import { addWeeks, format, isAfter, isBefore, parseISO, getDay } from "date-fns";

export interface Occurrence {
  date: string; // yyyy-MM-dd
  dayOfWeek: number;
}

/**
 * Calculate all occurrence dates for a recurring_booking within a date range.
 */
export function getSubscriptionOccurrences(
  subscription: {
    valid_from: string;
    valid_until: string;
    day_of_week: number;
    interval_weeks?: number;
    skipped_dates?: string[] | null;
  },
  periodFrom?: string,
  periodTo?: string,
): Occurrence[] {
  const subFrom = parseISO(subscription.valid_from);
  const subUntil = parseISO(subscription.valid_until);
  const intervalWeeks = subscription.interval_weeks || 1;
  const skipped = new Set(subscription.skipped_dates ?? []);

  // Find the first occurrence date (first date >= valid_from with matching day_of_week)
  const cursor = new Date(subFrom);
  while (getDay(cursor) !== subscription.day_of_week) {
    cursor.setDate(cursor.getDate() + 1);
  }

  const rangeFrom = periodFrom ? parseISO(periodFrom) : subFrom;
  const rangeTo = periodTo ? parseISO(periodTo) : subUntil;

  const occurrences: Occurrence[] = [];
  let current = new Date(cursor);
  while (!isAfter(current, subUntil) && !isAfter(current, rangeTo)) {
    const dateStr = format(current, "yyyy-MM-dd");
    if (!isBefore(current, rangeFrom) && !isAfter(current, rangeTo) && !skipped.has(dateStr)) {
      occurrences.push({ date: dateStr, dayOfWeek: subscription.day_of_week });
    }
    current = addWeeks(current, intervalWeeks);
  }

  return occurrences;
}
